import { createTheme, ThemeProvider, useMediaQuery } from '@mui/material';
import { ReactNode, useMemo } from 'react';
import { useStore } from 'react-admin';
import { THEME_MODE_KEY, ThemeMode, themeFor } from './themes';

/**
 * Themes everything inside it by the chosen mode, following the system while "system" is chosen.
 * Worked out while rendering rather than pushed into react-admin's theme store, so the first paint
 * after a reload already has the chosen mode.
 */
const ThemeModeProvider = ({ children }: { children: ReactNode }) => {
  const [mode] = useStore<ThemeMode>(THEME_MODE_KEY, 'light');
  const systemPrefersDark = useMediaQuery('(prefers-color-scheme: dark)', { noSsr: true });
  const options = themeFor(mode, systemPrefersDark);
  const theme = useMemo(() => createTheme(options), [options]);
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

export default ThemeModeProvider;
